import { createSelector } from 'reselect';

import { getRouteDepotStats } from './routes';
import { getSectionDepotStats } from './sections';
import { getUserDepots } from './user';
import { getSelectedDepot } from './app';
import { depotWightException } from '../../models/depot';

export const getDepotStatsObject = createSelector(
  getRouteDepotStats,
  getSectionDepotStats,
  (_, isRouteTab) => isRouteTab,
  (routeDepotStats, sectionDepotStats, isRouteTab) =>
    isRouteTab ? routeDepotStats : sectionDepotStats
);

export const getDepotWeightException = createSelector(
  getUserDepots,
  getSelectedDepot,
  depotWightException
);
